export default __webpack_public_path__ + "static/media/Img02.e7820604.png";